/**
 * Navbar — Fixed top navigation for public marketing pages.
 */
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './Navbar.module.css';

const NAV_LINKS = [
  { path: '/', label: 'Home' },
  { path: '/about', label: 'About' },
  { path: '/robot', label: 'Robot' },
  { path: '/sponsors', label: 'Sponsors' },
  { path: '/contact', label: 'Contact' },
];

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav className={`${styles.nav} ${scrolled ? styles.navScrolled : ''}`}>
      <div className={styles.inner}>
        <Link to="/" className={styles.logo}>
          Roarbotics
        </Link>

        <ul className={`${styles.links} ${menuOpen ? styles.linksOpen : ''}`}>
          {NAV_LINKS.map(({ path, label }) => (
            <li key={path}>
              <Link
                to={path}
                className={`${styles.link} ${isActive(path) ? styles.linkActive : ''}`}
              >
                {label}
              </Link>
            </li>
          ))}
          <li className={styles.mobilePanel}>
            <Link to="/join" className={`roar-btn roar-btn-primary ${styles.cta}`}>
              Join the team
            </Link>
          </li>
        </ul>

        <div className={styles.ctaWrap}>
          <Link to="/join" className={`roar-btn roar-btn-primary ${styles.cta}`}>
            Join the team
          </Link>
        </div>

        <button
          type="button"
          className={styles.menuBtn}
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((o) => !o)}
        >
          <span className={styles.menuIcon} />
        </button>
      </div>
    </nav>
  );
}

export default Navbar;
